import { AccountPanelTypes } from '../AccountPanelTypes';
import { Link, navigate } from 'gatsby';

export const footerConfig = {
  goBack: navigate,
  logoutCall: 'test',
};

export const sideBarConfig: AccountPanelTypes.TSideBarItem[] = [
  {
    url: `pay-rent`,
    linkName: 'Pay Rent',
    icon: 'FaMoneyBillAlt',
    RenderAs: Link,
  },
  {
    url: `check-balance`,
    linkName: 'Check Balance Details',
    icon: 'FaMoneyCheckAlt',
    RenderAs: Link,
  },
  {
    url: `auto-pay`,
    linkName: 'Auto Pay',
    icon: 'FaSyncAlt',
    RenderAs: Link,
  },
  {
    url: `reservations`,
    linkName: 'Reservations',
    icon: 'FaSyncAlt',
    RenderAs: Link,
  },
  {
    url: `update-payment`,
    linkName: 'Update Payment Details',
    icon: 'FaFileInvoiceDollar',
    RenderAs: Link,
  },
  {
    url: `update-contact`,
    linkName: 'Update Contact Details',
    icon: 'FaHeadset',
    RenderAs: Link,
  },
  {
    url: `account-settings`,
    linkName: 'Account Settings',
    icon: 'FaWrench',
    RenderAs: Link,
  },
  {
    url: `gate-access-code`,
    linkName: 'Gate Access Code',
    icon: 'FaDoorClosed',
    RenderAs: Link,
  },
];

export const currentPageHeadline = () => {
  const currUrl = window.location.href;
  const CheckBalancePageRegex = /check-balance/i;
  const UpdateContactPagRegex = /update-contact/i;
  const UpdatePaymentPageRegex = /update-payment/i;
  const AutoPayPageRegex = /auto-pay/i;
  const AccountSettingsPageRegex = /account-settings/i;
  const GateAccessPageRegex = /gate-access-code/i;
  const ReservationPageRegex = /reservation/i;

  switch (true) {
    case CheckBalancePageRegex.test(currUrl):
      return 'Check Balance';
    case UpdateContactPagRegex.test(currUrl):
      return 'Update Contact Details';
    case UpdatePaymentPageRegex.test(currUrl):
      return 'Update Payment Details';
    case AutoPayPageRegex.test(currUrl):
      return 'Auto Pay';
    case AccountSettingsPageRegex.test(currUrl):
      return 'Account Settings';
    case GateAccessPageRegex.test(currUrl):
      return 'Gate Access Code';
    case ReservationPageRegex.test(currUrl):
      return 'Reservations';
    default:
      return 'Pay Rent';
  }
};
